import { forwardRef } from 'react';
import { Form, Input, Hint } from '@heathmont/moon-core-tw';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import Translate from '~/client/shared/i18n/Translate';

type Props = { defaultValue?: string; errors?: boolean };

const EmailInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { errors = false, defaultValue = '', ...inputProps } = props;
  return (
    <Form.Item>
      <Input
        {...inputProps}
        type="email"
        defaultValue={defaultValue}
        placeholder={useTranslation('support.email')}
        ref={ref}
        error={errors}
      />
      {errors && (
        <Hint>
          <Translate id="errors.input.required" />
        </Hint>
      )}
    </Form.Item>
  );
});

export default EmailInput;
